let accessToken = null;

export const setAccessToken = (newAccessToken) => {
    accessToken = newAccessToken;
};

export const getAccessToken = () => accessToken;
